module.exports = __webpack_public_path__ + "media/icons/osoba-prywatna-unactive@2x-f424a42b.png";